/* SHUNGITE M.A.Y.A. — il negozio su Shopify: filtri della griglia e scheda prodotto. Generato da
   strumenti/tema-shopify.py: i filtri e la galleria vengono dalla landing (sito/assets/js/negozio.js), la scelta
   della variante da strumenti/shopify-js/scheda-prodotto.js. «Aggiungi al carrello» lo fa il <product-form> di Dawn. */
(function () {
  'use strict';
  var MAX = 99;
  var calmo = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function euro(n) { return Number(n).toLocaleString('it-IT') + ' €'; }
  function norm(s) {
    return (s || '').toLowerCase().replace(/×/g, 'x').normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function testo(sel) { var el = $(sel); return el ? el.textContent.trim() : ''; }

  /* ══ IL NEGOZIO: filtri, ricerca, ordinamento, contatore ══ */
  var neg = $('[data-negozio]');
  if (neg) (function () {
    var fissa = neg.getAttribute('data-collezione-fissa') || '';
    var griglia = $('[data-griglia]', neg);
    var schede = $$('.scheda[data-ordine]', griglia);
    var invito = $('.scheda--invito', griglia);
    var cerca = $('[data-cerca]', neg), ordina = $('[data-ordina]', neg);
    var qs = new URLSearchParams(window.location.search);
    function esiste(f, v) { return !!v && !!$('[data-filtro="' + f + '"][data-valore="' + v.replace(/[^a-z0-9-]/g, '') + '"]', neg); }
    var stato = {
      collezione: !fissa && esiste('collezione', qs.get('collezione') || '') ? qs.get('collezione') : '',
      categoria: esiste('categoria', qs.get('categoria') || '') ? qs.get('categoria') : '',
      q: (qs.get('q') || '').slice(0, 60),
      ordina: qs.get('ordina') || 'evidenza'
    };
    if (cerca) cerca.value = stato.q;
    if (ordina && $('option[value="' + stato.ordina.replace(/[^a-z-]/g, '') + '"]', ordina)) ordina.value = stato.ordina; else stato.ordina = 'evidenza';

    function va(s, senzaCategoria) {
      if (stato.collezione) {
        if (stato.collezione === 'elite') { if (s.getAttribute('data-elite') !== '1') return false; }
        else if (s.getAttribute('data-collezione') !== stato.collezione) return false;
      }
      if (!senzaCategoria && stato.categoria && s.getAttribute('data-categoria') !== stato.categoria) return false;
      if (stato.q) {
        var n = ' ' + norm(s.getAttribute('data-cerca') || s.getAttribute('data-nome')) + ' ';
        var parole = norm(stato.q).split(' ');
        for (var i = 0; i < parole.length; i++) if (parole[i] && n.indexOf(parole[i]) < 0) return false;
      }
      return true;
    }
    function pulisciCategoria() {   // una categoria che con gli altri filtri non ha prodotti si toglie
      var c = stato.categoria;
      if (c && !schede.some(function (s) { return s.getAttribute('data-categoria') === c && va(s, true); })) stato.categoria = '';
    }
    function prezzo(s) { var p = s.getAttribute('data-prezzo'); return p === '' ? null : Number(p); }
    function confronta(a, b) {
      var oa = Number(a.getAttribute('data-ordine')), ob = Number(b.getAttribute('data-ordine'));
      if (stato.ordina === 'nome') return a.getAttribute('data-nome').localeCompare(b.getAttribute('data-nome'), 'it');
      if (stato.ordina === 'prezzo-su' || stato.ordina === 'prezzo-giu') {
        var pa = prezzo(a), pb = prezzo(b);
        if (pa === null && pb === null) return oa - ob;
        if (pa === null) return 1;
        if (pb === null) return -1;
        return stato.ordina === 'prezzo-su' ? (pa - pb || oa - ob) : (pb - pa || oa - ob);
      }
      return oa - ob;
    }
    function applica(scriviUrl) {
      schede.slice().sort(confronta).forEach(function (s) { griglia.appendChild(s); });
      if (invito) griglia.appendChild(invito);
      var visibili = 0;
      schede.forEach(function (s) {
        var ok = va(s, false);
        s.hidden = !ok;
        if (ok) { visibili++; s.classList.add('in', 'fatto'); }
      });
      if (invito) invito.hidden = visibili !== schede.length;   // l'invito chiude la griglia intera
      $$('[data-filtro]', neg).forEach(function (b) {
        var f = b.getAttribute('data-filtro'), v = b.getAttribute('data-valore');
        b.setAttribute('aria-pressed', String(stato[f] === v));
        if (f === 'categoria' && v) {   // si vedono solo le categorie che hanno prodotti con gli altri filtri
          b.hidden = !schede.some(function (s) { return s.getAttribute('data-categoria') === v && va(s, true); });
        }
      });
      var conta = $('[data-conta]', neg);
      if (conta) {
        conta.textContent = visibili;
        $('[data-conta-uno]', neg).hidden = visibili !== 1;
        $('[data-conta-molti]', neg).hidden = visibili === 1;
      }
      $('[data-nessuno]', neg).hidden = visibili > 0;
      if (scriviUrl) {
        var p = new URLSearchParams();
        if (stato.collezione) p.set('collezione', stato.collezione);
        if (stato.categoria) p.set('categoria', stato.categoria);
        if (stato.q) p.set('q', stato.q);
        if (stato.ordina !== 'evidenza') p.set('ordina', stato.ordina);
        var s = p.toString();
        history.replaceState(null, '', window.location.pathname + (s ? '?' + s : '') + window.location.hash);
      }
    }
    $$('[data-filtro]', neg).forEach(function (b) {
      b.addEventListener('click', function () {
        var f = b.getAttribute('data-filtro');
        stato[f] = b.getAttribute('data-valore');
        if (f === 'collezione') pulisciCategoria();
        applica(true);
      });
    });
    var attesa;
    if (cerca) cerca.addEventListener('input', function () {
      window.clearTimeout(attesa);
      attesa = window.setTimeout(function () { stato.q = cerca.value.trim(); applica(true); }, 140);
    });
    if (ordina) ordina.addEventListener('change', function () { stato.ordina = ordina.value; applica(true); });
    var az = $('[data-azzera]', neg);
    if (az) az.addEventListener('click', function () {
      stato.collezione = ''; stato.categoria = ''; stato.q = ''; if (cerca) cerca.value = '';
      applica(true);
    });
    pulisciCategoria();
    applica(window.location.search !== '');   /* un indirizzo con valori sbagliati torna pulito */
    if (window.location.hash === '#cerca' && cerca) {
      window.setTimeout(function () { cerca.scrollIntoView({ block: 'center' }); cerca.focus({ preventScroll: true }); }, 60);
    }
  })();

  /* ══ LA SCHEDA PRODOTTO (Shopify) ══
     Le varianti arrivano dal JSON della pagina: id, testo, prezzo in centesimi, se si compra, pezzi in magazzino
     (massimo nel carrello), foto (indice). Una variante a 0 € è a prezzo da chiedere: «Prezzo su richiesta» e
     «Chiedi il prezzo». Una variante col prezzo ma finita: il prezzo resta e il pulsante dice «Esaurito». */
  var sp = $('[data-prodotto-shopify]');
  if (sp) (function () {
    var varianti = JSON.parse(($('[data-varianti-json]', sp) || {}).textContent || '[]');
    var nome = sp.getAttribute('data-nome') || '';
    var sel = Number(sp.getAttribute('data-scelta') || 0);
    var prezzoEl = $('[data-prezzo]', sp);
    var suRichiesta = prezzoEl.getAttribute('data-su-richiesta') || '';
    var acquisto = $('[data-azioni-acquisto]', sp), richiesta = $('[data-azioni-richiesta]', sp);
    var chiedi = $('[data-chiedi-prezzo]', sp);
    var idInput = $('input[name="id"]', sp);
    var q = $('[data-q]', sp), qMeno = $('[data-q-meno]', sp), qPiu = $('[data-q-piu]', sp);
    var aggiungi = acquisto && $('button[name="add"]', acquisto), aggiungiTesto = aggiungi && $('[data-aggiungi-testo]', aggiungi);
    var massimo = MAX;
    var pesoEl = $('[data-peso]', sp), pesoV = pesoEl && $('[data-peso-valore]', pesoEl);   /* 3 Step, voce 6b */

    /* galleria: binario che scorre col dito, miniature, ingrandimento */
    var bin = $('[data-binario]', sp);
    var diapo = bin ? $$('.galleria__diapo', bin) : [];
    var mini = $$('[data-vai]', sp);
    var attuale = 0;
    function segnaMini(i) {
      attuale = i;
      mini.forEach(function (m, k) { if (k === i) m.setAttribute('aria-current', 'true'); else m.removeAttribute('aria-current'); });
    }
    function vai(i, subito) {
      if (!bin || !diapo[i]) return;
      bin.scrollTo({ left: diapo[i].offsetLeft - diapo[0].offsetLeft, behavior: subito || calmo ? 'auto' : 'smooth' });
      segnaMini(i);
    }
    mini.forEach(function (m) { m.addEventListener('click', function () { vai(Number(m.getAttribute('data-vai'))); }); });
    if (bin && 'IntersectionObserver' in window) {
      var oss = new IntersectionObserver(function (voci) {
        voci.forEach(function (v) { if (v.isIntersecting && v.intersectionRatio > 0.6) segnaMini(Number(v.target.getAttribute('data-i'))); });
      }, { root: bin, threshold: [0.6] });
      diapo.forEach(function (d) { oss.observe(d); });
    }
    var lente = $('[data-lente]'), lenteImg = lente && $('[data-lente-img]', lente), daZoom = null;
    function grande(i) {
      var img = $('img', diapo[i]);
      var set = (img.getAttribute('srcset') || '').split(',').map(function (x) { return x.trim().split(' ')[0]; });
      return { src: set[set.length - 1] || img.src, alt: img.alt };
    }
    function mostra(i) {
      attuale = (i + diapo.length) % diapo.length;
      var g = grande(attuale);
      lenteImg.src = g.src; lenteImg.alt = g.alt;
    }
    function apriLente(i) {
      if (!lente) return;
      daZoom = document.activeElement;
      mostra(i); lente.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      $('[data-lente-chiudi]', lente).focus();
    }
    function chiudiLente() {
      if (!lente || lente.hidden) return;
      lente.hidden = true; document.documentElement.style.overflow = '';
      lenteImg.removeAttribute('src');
      vai(attuale, true);
      if (daZoom) daZoom.focus();
    }
    $$('[data-zoom]', sp).forEach(function (b) { b.addEventListener('click', function () { apriLente(Number(b.getAttribute('data-zoom'))); }); });
    if (lente) {
      $('[data-lente-chiudi]', lente).addEventListener('click', chiudiLente);
      $('[data-lente-prima]', lente).addEventListener('click', function () { mostra(attuale - 1); });
      $('[data-lente-dopo]', lente).addEventListener('click', function () { mostra(attuale + 1); });
      lente.addEventListener('click', function (ev) { if (ev.target === lente) chiudiLente(); });
      document.addEventListener('keydown', function (ev) {
        if (lente.hidden) return;
        if (ev.key === 'Escape') chiudiLente();
        if (ev.key === 'ArrowLeft') mostra(attuale - 1);
        if (ev.key === 'ArrowRight') mostra(attuale + 1);
        if (ev.key === 'Tab') {                                       // il fuoco resta nella lente
          var f = $$('button', lente);
          if (ev.shiftKey && document.activeElement === f[0]) { ev.preventDefault(); f[f.length - 1].focus(); }
          else if (!ev.shiftKey && document.activeElement === f[f.length - 1]) { ev.preventDefault(); f[0].focus(); }
        }
      });
      var x0 = null;
      lente.addEventListener('touchstart', function (ev) { x0 = ev.touches[0].clientX; }, { passive: true });
      lente.addEventListener('touchend', function (ev) {
        if (x0 === null) return;
        var dx = ev.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 50) mostra(attuale + (dx < 0 ? 1 : -1));
      });
    }

    function soldi(c) {
      var n = c / 100;
      return n.toLocaleString('it-IT', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }) + ' €';
    }
    var chip = $$('.chip--variante', sp);
    function messaggio(v) {
      if (!chiedi) return '';
      var m = varianti.length > 1 ? chiedi.getAttribute('data-modello-var') : chiedi.getAttribute('data-modello');
      return (m || '').replace('[prodotto]', nome).replace('[variante]', v.t);
    }
    function scegli(j, daUtente) {
      sel = j;
      var v = varianti[j];
      if (!v) return;
      chip.forEach(function (c, k) { c.setAttribute('aria-checked', String(k === j)); c.tabIndex = k === j ? 0 : -1; });
      if (daUtente) {                     /* prima della scelta resta «Da …» */
        prezzoEl.textContent = v.p > 0 ? soldi(v.p) : suRichiesta;
        if (!calmo) { prezzoEl.classList.remove('cambia'); void prezzoEl.offsetWidth; prezzoEl.classList.add('cambia'); }
        try { history.replaceState(null, '', window.location.pathname + '?variant=' + v.id + window.location.hash); } catch (e) {}
      }
      if (idInput) idInput.value = v.id;
      if (pesoEl) { pesoEl.hidden = !v.w; pesoV.textContent = v.w || ''; }
      if (acquisto) acquisto.hidden = !(v.p > 0);
      if (richiesta) richiesta.hidden = v.p > 0;
      if (aggiungi) {
        aggiungi.disabled = !v.a;
        if (aggiungiTesto) aggiungiTesto.textContent = v.a ? aggiungi.getAttribute('data-aggiungi') : aggiungi.getAttribute('data-esaurito');
      }
      massimo = Math.max(1, Math.min(MAX, v.m || MAX));
      if (q) { q.max = massimo; q.value = Math.min(quanti(), massimo); statoQ(); }
      if (chiedi) chiedi.href = '/pages/contatti?messaggio=' + encodeURIComponent(messaggio(v)) + '#scrivici';
      if (v.f >= 0) vai(v.f, !daUtente);
    }
    chip.forEach(function (c, k) {
      c.addEventListener('click', function () { scegli(k, true); });
      c.addEventListener('keydown', function (ev) {
        var d = (ev.key === 'ArrowRight' || ev.key === 'ArrowDown') ? 1 : (ev.key === 'ArrowLeft' || ev.key === 'ArrowUp') ? -1 : 0;
        if (!d) return;
        ev.preventDefault();
        var n = (k + d + chip.length) % chip.length;
        scegli(n, true); chip[n].focus();
      });
    });
    function quanti() { return Math.max(1, Math.min(massimo, parseInt(q.value, 10) || 1)); }
    function statoQ() { if (q) { qMeno.disabled = quanti() <= 1; qPiu.disabled = quanti() >= massimo; } }
    if (q) {
      qMeno.addEventListener('click', function () { q.value = Math.max(1, quanti() - 1); statoQ(); if (qMeno.disabled) q.focus(); });
      qPiu.addEventListener('click', function () { q.value = Math.min(massimo, quanti() + 1); statoQ(); if (qPiu.disabled) q.focus(); });
      q.addEventListener('change', function () { q.value = quanti(); statoQ(); });
      statoQ();
    }
    scegli(sel, false);
  })();

})();
